import { render, staticRenderFns } from "./AppartmentRecap.vue?vue&type=template&id=ebb81c34&scoped=true&"
import script from "./AppartmentRecap.vue?vue&type=script&lang=ts&"
export * from "./AppartmentRecap.vue?vue&type=script&lang=ts&"
import style0 from "./AppartmentRecap.vue?vue&type=style&index=0&id=ebb81c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb81c34",
  null
  
)

export default component.exports